let instance = null;
const SELECTED_FILTERS = 'selected-filters';

class FiltersSessionStorage {
	constructor() {
		if (!instance) {
			instance = this;
		}

		return instance;
	}

	/**
	 * @return {FiltersSessionStorage}
	 */
	static getInstance() {
		if (!FiltersSessionStorage._instance) {
			FiltersSessionStorage._instance = new FiltersSessionStorage()
		}

		return FiltersSessionStorage._instance;
	}

	setLastSelectedFilters(filters) {
		sessionStorage.setItem(SELECTED_FILTERS, JSON.stringify(filters));
	}

	getAndDeleteLastSelectedFilters() {
		const filtersJson = sessionStorage.getItem(SELECTED_FILTERS);
		const filters = filtersJson ? JSON.parse(filtersJson) : null;

		sessionStorage.removeItem(SELECTED_FILTERS);

		return filters;
	}
}

export default FiltersSessionStorage;
